import axios from '@/request';
import qs from 'qs';

export default {
  async list(params: any) {
    return axios.get('payments/list', { params });
  },
  async export(params: any) {
    return axios.get('payments/export', {
      params,
      responseType: 'blob'
    });
  },
  async withdraw(params: any) {
    return axios.get('withdraw/list', { params });
  },
  async exportwithdraw(params: any) {
    return axios.get('withdraw/export', {
      params,
      responseType: 'blob'
    });
  },
  async opAIBoxPrice(params:any){
    return axios.get('payments/aibox', { params });
  }
};
